import { render, staticRenderFns } from "./AffiliateInfo.vue?vue&type=template&id=8cd2111c&scoped=true&"
import script from "./AffiliateInfo.vue?vue&type=script&lang=js&"
export * from "./AffiliateInfo.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateInfo.vue?vue&type=style&index=0&id=8cd2111c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd2111c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VImg,VRow})
